(() => {
  'use strict';

  const desktopMedia = window.matchMedia('(min-width: 1200px)');
  const storageKey = 'chandamama-desktop-filter-hidden';

  function formatCount(text) {
    if (!text) return 'Items found';

    const match = String(text).match(/[\d,.]+/);
    if (!match) return String(text).trim();

    const displayNumber = match[0];
    const number = Number(displayNumber.replace(/[^\d]/g, ''));
    return `${displayNumber} ${number === 1 ? 'item' : 'items'} found`;
  }

  function initDesktopCollectionToolbar() {
    if (!desktopMedia.matches) return;

    const section = document.querySelector('.collection.collection--with-sidebar.js-collection');
    if (!section) return;

    const body = section.querySelector('.collection__body');
    const sidebar = section.querySelector('.collection__sidebar');
    const sourceSort = sidebar && sidebar.querySelector('select[name="sort_by"]');

    if (!body || !sidebar || !sourceSort) return;

    const existingToolbar = section.querySelector('.cm-desktop-collection-toolbar');
    if (existingToolbar) return;

    if (!sidebar.id) sidebar.id = 'cmCollectionSidebar';

    const initialCountNode = sidebar.querySelector('.product-filters__count-text span[aria-hidden="true"]');
    const initialCountText = initialCountNode ? initialCountNode.textContent.trim() : '';

    const toolbar = document.createElement('div');
    toolbar.className = 'cm-desktop-collection-toolbar';

    if (body.classList.contains('collection__body--max-width')) {
      toolbar.classList.add('cm-desktop-collection-toolbar--max-width');
    }

    toolbar.innerHTML = `
      <button
        type="button"
        class="cm-desktop-filter-toggle"
        aria-controls="${sidebar.id}"
        aria-expanded="true"
      >
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <path d="M4 6h5M13 6h7M4 12h9M17 12h3M4 18h3M11 18h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="11" cy="6" r="2" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="15" cy="12" r="2" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="9" cy="18" r="2" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        <span class="cm-desktop-filter-toggle-text">HIDE FILTER</span>
      </button>

      <div class="cm-desktop-toolbar-right">
        <span class="cm-desktop-product-count" aria-live="polite"></span>
        <span class="cm-desktop-toolbar-divider" aria-hidden="true"></span>
        <div class="cm-desktop-sort-group">
          <label class="cm-desktop-sort-label" for="cmDesktopSort">SORT BY</label>
          <div class="cm-desktop-sort-select-wrap">
            <span class="cm-desktop-sort-value" aria-hidden="true"></span>
            <span class="cm-desktop-sort-arrow" aria-hidden="true"></span>
            <select id="cmDesktopSort" class="cm-desktop-sort-select" aria-label="Sort products"></select>
          </div>
        </div>
      </div>
    `;

    body.parentNode.insertBefore(toolbar, body);

    const filterButton = toolbar.querySelector('.cm-desktop-filter-toggle');
    const filterButtonText = toolbar.querySelector('.cm-desktop-filter-toggle-text');
    const countText = toolbar.querySelector('.cm-desktop-product-count');
    const desktopSort = toolbar.querySelector('.cm-desktop-sort-select');
    const sortValue = toolbar.querySelector('.cm-desktop-sort-value');

    desktopSort.innerHTML = sourceSort.innerHTML;

    const urlSort = new URL(window.location.href).searchParams.get('sort_by');
    const preferredSortValue = urlSort || sourceSort.value;
    const hasPreferredValue = Array.from(desktopSort.options).some(
      (option) => option.value === preferredSortValue
    );

    if (preferredSortValue && hasPreferredValue) {
      desktopSort.value = preferredSortValue;
    } else if (sourceSort.selectedIndex >= 0) {
      desktopSort.selectedIndex = sourceSort.selectedIndex;
    }

    function updateSortLabel() {
      const selectedOption = desktopSort.options[desktopSort.selectedIndex];
      const selectedText = selectedOption ? selectedOption.textContent.trim() : '';
      sortValue.textContent = selectedText || 'Best selling';
    }

    updateSortLabel();

    function setFilterState(hidden, persist) {
      section.classList.toggle('cm-desktop-filter-hidden', hidden);
      filterButtonText.textContent = hidden ? 'SHOW FILTER' : 'HIDE FILTER';
      filterButton.setAttribute('aria-expanded', hidden ? 'false' : 'true');

      if (persist) {
        try {
          localStorage.setItem(storageKey, hidden ? '1' : '0');
        } catch (error) {
          // Storage can be unavailable in private browsing; the UI still works.
        }
      }
    }

    let storedHidden = false;
    try {
      storedHidden = localStorage.getItem(storageKey) === '1';
    } catch (error) {
      storedHidden = false;
    }
    setFilterState(storedHidden, false);

    filterButton.addEventListener('click', () => {
      setFilterState(!section.classList.contains('cm-desktop-filter-hidden'), true);
    });

    desktopSort.addEventListener('change', () => {
      updateSortLabel();
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', desktopSort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    function updateCount() {
      const activeCounter = sidebar.querySelector('.js-active-filters-counter');
      const activeFilters = activeCounter ? Number(activeCounter.textContent.trim()) : 0;
      const filteredCountNode = sidebar.querySelector(
        '.js-selected-filters-wrapper:not(.is-hidden) .product-filters__form-label span[aria-hidden="true"]'
      );

      if (activeFilters > 0 && filteredCountNode) {
        countText.textContent = formatCount(filteredCountNode.textContent);
      } else {
        countText.textContent = formatCount(initialCountText);
      }
    }

    updateCount();

    const observer = new MutationObserver(updateCount);
    observer.observe(sidebar, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopCollectionToolbar, { once: true });
  } else {
    initDesktopCollectionToolbar();
  }

  desktopMedia.addEventListener('change', (event) => {
    if (event.matches) initDesktopCollectionToolbar();
  });
})();